// extracted by mini-css-extract-plugin
module.exports = {"messageContainer":"styles-module__messageContainer___3SAkK","image":"styles-module__image___3Hz7z","link":"styles-module__link___2QkL5"};